import { Box, Flex } from '@chakra-ui/layout'
import { Button, Icon } from '@ubirider/pick-component-library'
import { signOut } from 'firebase/auth'
import firebase from '../../../../Firebase'
import { RouteButton } from './components/RouteButton'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import homeIcon from '../../../../assets/home.svg'
import travelIcon from '../../../../assets/operation.svg'
import cardIcon from '../../../../assets/credit_card.svg'
import accountIcon from '../../../../assets/settings.svg'
import supportIcon from '../../../../assets/message-circle.svg'
import ChevronDown from '../../../../assets/arrow_down.svg'
import { Collapse, Image, Text } from '@chakra-ui/react'

export function Menu() {
  const { t } = useTranslation()

  const [loading, setLoading] = useState(false)
  const [openWallet, setOpenWallet] = useState(location.pathname.includes('/wallet'))

  const [isHover, setIsHover] = useState(false)
  const handleMouseEnter = () => {
    setIsHover(true)
  }
  const handleMouseLeave = () => {
    setIsHover(false)
  }

  const logout = async () => {
    setLoading(true)
    await signOut(firebase)
  }

  useEffect(() => {
      setOpenWallet(location.pathname.includes('/wallet'))
  },[location.pathname])

  return (
    <Box>
      <Flex
        display={{ base: 'block', sm: 'none', md: 'none', lg: 'block' }}
        gap='24px'
        bg='neutral.100'
        rounded='4px'
        padding='16px'
        align='flex-start'
        minW={{ base: '332px', lg: '332px', xl: '332px' }}
      >
        <Flex gap='24px' direction='column'>
          <Flex direction='column' align='flex-start'>
            <RouteButton icon={homeIcon} label='home.home' route='/home' />

            <RouteButton icon={travelIcon} label='travel_history.travel_history' route='/travel-history' />

            <Flex
              justifyContent='space-between'
              width='100%'
              _hover={{ bg: '#E0EAFF', fontWeight: '700' }}
              padding={{ sm: '16px 8px', md: '16px 8px', lg: '16px 8px 16px 16px', xl: '16px 8px 16px 16px' }}
              rounded='4px'
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              as='button'
              onClick={() => setOpenWallet(!openWallet)}
            >
              <Flex gap='24px'>
                <Image w='24px' src={cardIcon} />
                <Text
                  variant='link'
                  color='neutral.800'
                  fontWeight={location.pathname.includes('/wallet') ? '700' : isHover ? '600' : '400'}
                  fontSize='18px'
                  _hover={{}}
                >
                  {t('demo.wallet')}
                </Text>
              </Flex>
              <Icon src={ChevronDown} flipped={openWallet} />
            </Flex>

            <Collapse in={openWallet} animateOpacity style={{ width: '100%', mt: '-24px' }}>
              <RouteButton label='demo.pick_card' route='/wallet/pick-card' />
              <RouteButton label='demo.other_cards' route='/wallet/other-cards' />
            </Collapse>
          </Flex>

          <Flex direction='column' align='flex-start'>
            <RouteButton icon={accountIcon} label='account.account' route='/account' />

            <RouteButton icon={supportIcon} label='customer_support.customer_support' route='/support' />
          </Flex>

          <Flex>
            <Button
              onClick={() => {
                logout()
              }}
              loading={loading}
              style='solid'
              type='secondary'
              label={t('home.logout_button')}
              css={{ width: '100%' }}
            />
          </Flex>
        </Flex>
      </Flex>
    </Box>
  )
}
